import type { NextRouter } from "next/router"
import { useRouter } from "next/router"

import { useToast } from "@chakra-ui/react"

import cookie from "cookie"
import type { ApolloClient } from "@apollo/client"
import { useApolloClient } from "@apollo/client"

import { SESSION_TOKEN } from "../config"

export const useLogout = () => {
  const apolloClient = useApolloClient()
  const router = useRouter()
  const toast = useToast()

  return () =>
    handleLogout({
      router,
      apolloClient,
      onSuccess: () => {
        toast({ status: "success", description: "Successfully logged out!" })
      },
    })
}

export const handleLogout = async ({
  router,
  apolloClient,
  onSuccess,
}: {
  router: NextRouter
  apolloClient: ApolloClient<object>
  onSuccess?: () => void
}) => {
  document.cookie = cookie.serialize(SESSION_TOKEN, "DONE", {
    maxAge: 0,
    path: "/",
  })
  await router.replace("/")
  await apolloClient.resetStore()

  if (onSuccess) {
    onSuccess()
  }
}
